















import Datepicker from 'vanillajs-datepicker/js/Datepicker.js';
import DatepickerOptions from './../../datepickerOptions';
import { format, formatDistance, formatRelative, subDays , addDays} from "date-fns";
import { da as dafns } from 'date-fns/locale';


Datepicker.locales.da = {
    days: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
    daysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
    daysMin: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
    months: ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"],
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    today: "I Dag",
    weekStart: 1,
    clear: "Nulstil",
    format: "dd/mm/yyyy",
    monthsTitle: "Måneder"
}



let currentDatePicker = null;
export default {
    props: {
        value: String,
        classes: String,
        name: String,
        displayName: String,
        displayDatePlaceholder: String,
        options: Object,
        minDate: String
    },
    created() {
        if (this.value != null) {
            this.chosenDate = new Date(this.value);
        }
       
    },
    mounted() {
        
        
        const datepickerEle : HTMLElement = this.$refs.datepicker;
        if (datepickerEle != null) {
            currentDatePicker = new Datepicker(datepickerEle, DatepickerOptions);
            if(this.chosenDate != null) {
                currentDatePicker.setDate(this.chosenDate);
            };

            currentDatePicker.setOptions({
                'minDate': new Date()
            });
           

            //Make events for datepicked and more.
            datepickerEle.addEventListener("changeDate",(event : CustomEvent) => {
                this.chosenDate = event.detail.date;
                this.changed();
            });
        }
    },
    watch: {
        minDate: function(value: Date) {      
            const thisDate = new Date(value);

            currentDatePicker.setOptions({
                'minDate': thisDate,
                'defaultViewDate': thisDate
            });

            if(thisDate > this.chosenDate) {
                this.chosenDate = thisDate;
                currentDatePicker.setDate(this.chosenDate, { render: true });
            }

        }
    },
    data() {
        return {
            chosenDate: null,
        };
    },
    computed: {
           formatDateToString: function() {
            if(this.chosenDate != null) {
                return format(this.chosenDate, "dd. MMM yyyy", { locale: dafns});
            }else  {
                return this.displayDatePlaceholder;
            }
        },
         formatDateToDateString : function() {
            if(this.chosenDate != null) {
                return format(this.chosenDate, "yyyy-MM-dd", { locale: dafns});
            }
        },
    },
    methods: {
     
       
        changed() {
            this.$emit("change",this.chosenDate);


        }
    },
};
